module.exports = __webpack_public_path__ + "static/media/api.80de5352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/api.png
// module id = 281
// module chunks = 1